import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `EventMarkersDirective` represent a event marker collection in Gantt
 * It must be contained in a Gantt component(`GanttComponent`).
 * ```tsx
 * <GanttComponent dataSource={data} allowSelection={true} allowSorting={true}>
 * <EventMarkersDirective>
 * <EventMarkerDirective day='02/10/2018' label='Project Starts'></EventMarkerDirective>
 * </EventMarkersDirective>
 * </GanttComponent>
 * ```
 */
export class EventMarkerDirective extends ComplexBase {
}
EventMarkerDirective.moduleName = 'eventMarker';
export class EventMarkersDirective extends ComplexBase {
}
EventMarkersDirective.propertyName = 'eventMarkers';
EventMarkersDirective.moduleName = 'eventMarkers';
